import React from 'react';
import { TrendingUp, BarChart3, Target, Zap } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingStats = () => {
  const { language } = useLanguage();

  const stats = language === 'fr' ? [
    {
      icon: TrendingUp,
      value: '79%',
      label: 'des avocats formés à l\'IA constatent un gain de productivité significatif',
      source: 'Thomson Reuters, 2025',
    },
    {
      icon: BarChart3,
      value: '4h',
      label: 'économisées en moyenne par semaine grâce à l\'IA générative en cabinet',
      source: 'LexisNexis Legal AI Survey, 2025',
    },
    {
      icon: Target,
      value: '67%',
      label: 'des cabinets ayant formé leurs équipes adoptent l\'IA plus rapidement',
      source: 'Wolters Kluwer Future Ready Lawyer, 2025',
    },
    {
      icon: Zap,
      value: '3×',
      label: 'plus de rétention des compétences avec une formation modulaire vs intensive',
      source: 'Harvard Business Review, 2024',
    },
  ] : [
    {
      icon: TrendingUp,
      value: '79%',
      label: 'of AI-trained lawyers report significant productivity gains',
      source: 'Thomson Reuters, 2025',
    },
    {
      icon: BarChart3,
      value: '4h',
      label: 'saved per week on average using generative AI in law firms',
      source: 'LexisNexis Legal AI Survey, 2025',
    },
    {
      icon: Target,
      value: '67%',
      label: 'of firms that trained their teams adopt AI faster and more effectively',
      source: 'Wolters Kluwer Future Ready Lawyer, 2025',
    },
    {
      icon: Zap,
      value: '3×',
      label: 'better skill retention with modular training vs intensive formats',
      source: 'Harvard Business Review, 2024',
    },
  ];

  return (
    <section className="py-20 bg-primary/5 border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-foreground mb-4 text-center">
          {language === 'fr' ? 'Pourquoi investir dans la formation IA ?' : 'Why Invest in AI Training?'}
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          {language === 'fr' 
            ? 'Les études convergent : la formation est le facteur n°1 de succès dans l\'adoption de l\'IA en cabinet.'
            : 'Research confirms: training is the #1 success factor in law firm AI adoption.'}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center bg-white rounded-xl p-6 shadow-sm border border-border">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
                <stat.icon className="w-6 h-6 text-primary" />
              </div>
              <div className="text-4xl font-bold text-primary mb-2">{stat.value}</div>
              <p className="text-sm text-muted-foreground mb-3">{stat.label}</p>
              <p className="text-xs text-muted-foreground/60 italic">{stat.source}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
